
<div class="profile-list">
    <div class="umc-avatar-container ud-component--user-manage--avatar">
        <img [src]="profile_picture" alt="profile_picture">
    </div>
    <h2 class="um-text-center umc-user-title ud-heading-md">{{fullName}}</h2>
    <div class="items">
        <ul>
            <li (click)="activateItem(2)" [class.active]="activeItem === 2">
                <a [routerLink]="['edit-profile']" title="Profile">Profile</a>
            </li>
            <li (click)="activateItem(3)" [class.active]="activeItem === 3">
                <a [routerLink]="['edit-photo']" title="Photo">Photo</a>
            </li>
            <li (click)="activateItem(4)" [class.active]="activeItem === 4">
            <a [routerLink]="['edit-account']" title="Acount security">Account Security</a></li>
           
            <li (click)="activateItem(5)" [class.active]="activeItem === 5">
            <a routerLink="user/manage-subscriptions" title="Subscriptions"> Subscriptions</a>
        </li>

        <li (click)="activateItem(6)" [class.active]="activeItem === 6">
            <a routerLink="['edit-payment-methods']" title="Payment methods">Payment Methods</a>
        </li>
        <li (click)="activateItem(7)" [class.active]="activeItem === 7" title="Notification">
            <a [routerLink]="['edit-notifications']">Notification</a></li>
            <li (click)="activateItem(8)" [class.active]="activeItem === 8" title="Cloase accound">
                <a [routerLink]="['close-account']">Close Account</a></li>
        </ul>
    </div>
</div>